import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NotificationModel } from 'src/app/models/notification.model';
import { MenuItem, RichDataModel } from 'src/app/models/rich-data.model';
import { Survey } from 'src/app/models/survey.model';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { RequestService } from 'src/app/services/request.service';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
})
export class SurveyComponent {

  @Input() data: MenuItem;
  @Input() richData: RichDataModel;
  @Input() notificationData: NotificationModel;

  rate = 0;

  processing = false;

  constructor(
    public dataServ: DataService,
    private mdlctrl: ModalController,
    private surveyServ: SurveyService,
    private authServ: AuthService,
    private requestServ: RequestService,
    private modalServ: ModalMakerService
  ) { }

  async close() {
    await this.mdlctrl.dismiss();
  }

  async send() {

    this.processing = true;

    if(!this.authServ.isLogged) {
      this.modalServ.login();
      this.processing = false;
      return;
    }

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    const TITLE = this.data ? this.data.survey_title : this.richData ? this.richData.survey_title : this.notificationData.title;
    const DESC = this.data ? this.data.survey_description : this.richData
      ? this.richData.survey_description : this.notificationData.description;
    const TYPE = this.data ? 'Menu Item' : this.richData ? 'Hotel' : 'Notification';

    const SURVEYDATA = new Survey(this.authServ.profile, TITLE, DESC, this.rate, TYPE);

    if (this.data) {
      SURVEYDATA.item_id = this.data.id;
    } else if (this.notificationData) {
      SURVEYDATA.survey_header_id = this.notificationData.id;
      SURVEYDATA.request_id = this.notificationData.request_id;

      try {
        const REQ = await this.requestServ.getRequestById(this.notificationData.request_id);

        if (REQ) {
          REQ.callback_survey_rating = this.rate;
          await this.requestServ.putRequest(REQ);
        }
      } catch { }
    }

    await this.surveyServ.postSurvey(SURVEYDATA);
    if (this.notificationData && this.notificationData.request_id) {
      await this.surveyServ.getSurveyByRequestId(this.notificationData.request_id);
    }

    this.close();
    this.processing = false;
  }
}
